var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import EdsFormControl, { FormControlLabel as EdsFormControlLabel } from '@ellucian/react-design-system/core/es/FormControl';
import EdsRadio, { RadioGroup as EdsRadioGroup } from '@ellucian/react-design-system/core/es/Radio';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = (theme) => createStyles({
    groupRowAligned: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            flexDirection: 'row'
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    }
});
const RadioGroup = (props) => {
    const { classes, complementClassName, id, isRowAligned, labelElement, options, name } = props, rest = __rest(props, ["classes", "complementClassName", "id", "isRowAligned", "labelElement", "options", "name"]);
    const radios = [];
    if (Array.isArray(options) && options.length > 0) {
        options.forEach((item, i) => radios.push((React.createElement(EdsFormControlLabel, { id: `fcl${id}_${i}`, control: (React.createElement(EdsRadio, { "aria-label": item.description })), disabled: item.disabled, key: `${name}_${i}`, label: (React.createElement(React.Fragment, null,
                item.description,
                item.nodeComplement ? (complementClassName ? (React.createElement("span", { className: complementClassName }, item.nodeComplement)) : (React.createElement(React.Fragment, null, item.nodeComplement))) : undefined)), value: String(item.value) }))));
    }
    else {
        const option = options;
        radios.push((React.createElement(EdsFormControlLabel, { id: `fcl${id}`, control: React.createElement(EdsRadio, { "aria-label": option.description }), label: (React.createElement(React.Fragment, null,
                option.description,
                option.nodeComplement ? (complementClassName ? (React.createElement("span", { className: complementClassName }, option.nodeComplement)) : (React.createElement(React.Fragment, null, option.nodeComplement))) : undefined)), value: String(option.value) })));
    }
    return (React.createElement(EdsFormControl, { id: `fc${name}`, component: "fieldset" },
        labelElement,
        React.createElement(EdsRadioGroup, Object.assign({ className: isRowAligned ? classes.groupRowAligned : undefined, id: id, name: name }, rest), radios)));
};
export default withStyles(styles)(RadioGroup);
